import { mapActions, mapGetters } from 'vuex'
import types from '../../store/globaltypes'
import card from '../card'
import infoline from '../infoline'
import timeline from '../timeline'
import { getAllLinkedProductIdsForMethod } from '../../helpers/crops'

export default {
  name: 'cultivationmethods',
  components: { card, infoline, timeline },
  props: ['crop'],
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      groupedProducts: types.products.getters.groupByCategory,
      multiLanguageCropById: types.crops.getters.multiLanguageCropById,
      locale: types.user.getters.localeCode
    }),
    isSowingAction () {
      return (index, step) => {
        const actiontype = this.actionType(index, step)
        return actiontype && (actiontype.toLowerCase() === 'zaaien' || actiontype.toLowerCase() === 'voorzaaien')
      }
    },
    sowingDepth () {
      const from = this.crop[`sowing_depth_from`]
      const to = this.crop[`sowing_depth_to`]
      return `${from}cm - ${to}cm`
    },
    spaceBetweenPlants () {
      return (index) => this.crop[`method${index}_space_between_plants`]
    },
    spaceBetweenRows () {
      return (index) => this.crop[`method${index}_space_between_rows`]
    },
    title () {
      return (index, step) => this.crop[`method${index}action${step}_action_type`]
    },
    tips () {
      return (index, step) => this.crop[`method${index}action${step}_tips`]
    },
    period () {
      return (index, step) => {
        const currentYear = this.moment().year()

        var from = this.crop[`method${index}action${step}_period_from`]
        var to = this.crop[`method${index}action${step}_period_to`]

        if (to) {
          to = this.moment(to).year(currentYear)
          if (to.isBefore(this.moment().subtract(30, 'days'))) {
            to = this.moment(to).year(currentYear + 1)
          }
        }

        if (from) {
          from = this.moment(from).year(currentYear)
          if (from.isBefore(this.moment().subtract(30, 'days'))) {
            from = this.moment(from).year(to.year())
            if (from.isAfter(to)) {
              from = this.moment(from).year(to.year() - 1)
            }
          }
        }

        if (to && from && this.moment.isMoment(to) && this.moment.isMoment(from)) {
          return {
            from: from,
            to: to
          }
        } else {
          const amount = (this.crop[`method${index}action${step}_period_number`] || 1)
          const period = this.crop[`method${index}action${step}_period_period`]
          const action = this.crop[`method${index}action${step}_period_action`]
          return {
            relative: true,
            amount: amount,
            period: period,
            action: action
          }
        }
      }
    },
    formattedPeriod () {
      return (index, step) => {
        var formattedPeriod = '---'
        const period = this.period(index, step)
        if (period && period.from && period.to) formattedPeriod = `${period.from.format('L')} - ${period.to.format('L')}`
        else if (period && period.relative) formattedPeriod = `${period.amount} ${period.period} after action${period.action}`
        return formattedPeriod
      }
    },
    location () {
      return (index, step) => {
        switch (this.crop[`method${index}action${step}_location`]) {
          case 'indoor': return this.$t('crops.indoor')
          case 'outdoor': return this.$t('crops.outdoor')
          case 'under glass': return this.$t('crops.under_glass')
          case 'propagator': return this.$t('crops.propagator')
        }
      }
    },
    condition () {
      return (index, step) => (this.crop[`method${index}action${step}_condition`] || false)
    },
    numConditions () {
      return (index, step) => this.condition(index, step) ? this.condition.index.step.length : 0
    },
    actionType () {
      return (index, step) => (this.crop[`method${index}action${step}_action_type`])
    },
    productIDs () {
      return (index, step) => {
        var prods = this.crop[`method${index}action${step}_linked_products`]
        if (!prods) return null
        prods = prods.split(';')
        prods.pop()
        var productIDs = []
        const regex = new RegExp(/\[(.*)\]/)
        prods.forEach(prod => {
          if (regex.test(prod) && prod.match(regex).length > 0) {
            productIDs.push(prod.match(/\[(.*)\]/)[1])
          }
        })
        return productIDs
      }
    },
    linkedProds () {
      return (index, step) => {
        var productIDs = this.productIDs(index, step)
        if (productIDs === null) return []
        return this.groupedProducts(productIDs)
      }
    },
    icon () {
      return (index, step) => {
        var icon = 'fa-seedling'
        // const actiontype = this.actionType(index, step)
        // if (actiontype) {
        //   switch (actiontype.toLowerCase()) {
        //     case 'zaaien':
        //       icon = 'fa-allergies'
        //       break
        //     case 'voorzaaien':
        //       icon = 'fa-allergies'
        //       break
        //     case 'verspenen':
        //       icon = 'fa-hands'
        //       break
        //     case 'grondvoorbereiding':
        //       icon = 'fa-swimmer'
        //       break
        //   }
        // }
        return icon
      }
    }
  },
  methods: {
    ...mapActions({
      addToCart: types.shoppingcart.actions.addItemToCart,
      loadProducts: types.products.actions.loadList
    }),
    onOpen (methodID) {
      const productIDs = getAllLinkedProductIdsForMethod(this.crop, methodID)
      this.loadProducts(productIDs)
    },
    selectStartDay (index) {
      const query = {
        cropname: this.crop.post_title.toLowerCase(),
        method: index
      }
      this.$router.push({ name: 'wizard', query })
    },
    addProductToCart (productID, variationID) {
      this.addToCart({
        productID,
        cropID: this.crop['key'],
        variationID: variationID
      })
      this.$ga.event({
        eventCategory: 'Product',
        eventAction: 'Product added to wishlist',
        eventLabel: `Added from page ${this.$route.name}`
      })
    }
  }
}
